import type { WindTypes } from "@/util/Tailwind";

interface TextPlaceholderProps
{
    width?: WindTypes["width"];
    height?: WindTypes["height"];
    rounded?: WindTypes["borderRadius"];
    baseColor?: WindTypes["backgroundColor"];
    marginBottom?: WindTypes["marginBottom"];
}

const TextPlaceholder = ({
    width = "w-32",
    height = "h-4",
    rounded = "rounded",
    baseColor = "bg-transparent",
    marginBottom = "mb-0"
}: TextPlaceholderProps) =>
{
    return (
        <div
            className={`${baseColor} ${width} ${height} ${rounded} ${marginBottom} shimmer blur-sm`}
        />
    );
};

export default TextPlaceholder;
